import React from 'react';
import { Dropdown, Menu } from '@fiverr-private/orca';
import If from '../../../../lib/If';
import { rollouts, user } from '../../../../PropTypes';
import MenuLocaleSettingsLink from '../../../LocaleSettingsLinks/MenuLocaleSettingsLink';
import LogoutLink from '../../../LogoutLink';
import {
    SellerAccountSettingsLink,
    SellerBillingLink,
    SellerProfileLink,
    SellerReferalLink,
} from '../../../SellerLinks';
import SwitchToBuying from '../../SwitchToBuying';
import UserAvatar from '../../../UserAvatar';
import AvatarHeader from '../../../AvatarHeader';
import { TeamDashboardInviteLink, TeamDashboardLink } from '../../../../composites/TeamAccountMember/MemberLinks';

import './style.scss';

const Avatar = (props, { user }) => {
    const isTeamAccountAdmin = user?.teamAccount?.slug === user?.username;

    return (
        <Dropdown
            position={Dropdown.POSITIONS.RIGHT}
            containerClassName="avatar-menu-container-top-header"
            menu={
                <Menu className="seller-menu avatar-menu">
                    <Menu.Item className="no-hover-background custom-item">
                        <AvatarHeader />
                    </Menu.Item>
                    <Menu.Item className="no-hover-background wider-part">
                        <SwitchToBuying sellerId={user.id} />
                    </Menu.Item>
                    <Menu.Divider />
                    <If condition={!!user.teamAccount}>
                        <Menu.Item>
                            <TeamDashboardLink teamOwnerUsername={user.teamAccount?.slug} />
                        </Menu.Item>
                        <If condition={isTeamAccountAdmin}>
                            <Menu.Item>
                                <TeamDashboardInviteLink teamOwnerUsername={user.teamAccount?.slug} />
                            </Menu.Item>
                        </If>
                    </If>
                    <Menu.Item>
                        <SellerProfileLink sellerId={user.id} sellerUsername={user.username} />
                    </Menu.Item>
                    <If condition={!!user.isReferralEligible}>
                        <Menu.Item>
                            <SellerReferalLink sellerId={user.id} />
                        </Menu.Item>
                    </If>
                    <Menu.Item>
                        <SellerAccountSettingsLink sellerId={user.id} />
                    </Menu.Item>
                    <Menu.Item>
                        <SellerBillingLink sellerId={user.id} />
                    </Menu.Item>
                    <Menu.Divider />
                    <MenuLocaleSettingsLink ItemWrapper={Menu.Item} />
                    <Menu.Divider />
                    <Menu.Item>
                        <LogoutLink />
                    </Menu.Item>
                </Menu>
            }
        >
            <UserAvatar
                fullName={user.fullName}
                username={user.username}
                profileImage={user.profileImage}
                isOnline={user.isOnline}
            />
        </Dropdown>
    );
};

Avatar.contextTypes = {
    user,
    rollouts,
};

export default Avatar;
